module.exports = __webpack_public_path__ + "static/media/pdf.bdf85f77.svg";